import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';

export const activeLanguageUpdated: EventEmitter<any> = new EventEmitter<any>();

const FALLBACK_LANG = 'en_us';

@Injectable({
  providedIn: 'root',
})
export class TranslateService {
  data: any = {};
  private lang: string;
  constructor(private readonly http: HttpClient) {}
  use(lang: string, isFallback = false): Promise<{}> {
    this.lang = lang;
    const timeFormat = moment().format('DMYYYYHH');
    return new Promise<{}>((resolve) => {
      lang = !lang ? localStorage.getItem('auth_user_language') : lang;
      moment.locale(lang);
      activeLanguageUpdated.emit(lang);
      const langPath = `assets/${lang || FALLBACK_LANG}.json?v=${timeFormat}`;
      this.http.get(langPath).subscribe(
        (translation) => {
          this.data = Object.assign({}, translation || {});
          resolve(this.data);
        },
        (error) => {
          // Keep whatever is already loaded — wiping it makes every key in the app render raw.
          console.error(`Failed to load translations from "${langPath}"`, error);
          if (!isFallback && lang !== FALLBACK_LANG && !Object.keys(this.data).length) {
            this.use(FALLBACK_LANG, true).then(resolve);
            return;
          }
          resolve(this.data);
        }
      );
    });
  }

  public getLang(): string {
    return this.lang;
  }
}
